import { ServiceType } from '../../../../../common/enums';

export type SettingsKey =
    | 'requestRecipient'
    | 'recipientIsOwnOrganization'
    | 'serviceGraderPool'
    | 'ksyosHolterAnalystOrganization'
    | 'zorgMail'
    | 'somnologyOrganization'
    | 'software'
    | 'embloomQuestionnaires'
    | 'serviceGroupSetting'
    | 'somnologyCanReferPatientWithoutSmartphone'
    | 'sendingHolter'
    | 'diagnosticEquipment'
    | 'hideRequestedExaminationTaskFeature';

function serviceOrganizationSettingsExaminationComponentsList(): SettingsKey[] {
    return [
        'hideRequestedExaminationTaskFeature',
        'requestRecipient',
        'serviceGraderPool',
        'sendingHolter',
        'ksyosHolterAnalystOrganization',
        'somnologyOrganization',
        'software',
        'embloomQuestionnaires',
        'serviceGroupSetting',
        'diagnosticEquipment',
    ];
}

function serviceOrganizationSettingsConsultationComponentsList(): SettingsKey[] {
    return ['requestRecipient', 'zorgMail', 'serviceGroupSetting'];
}

function serviceOrganizationSettingsReferralComponentsList(): SettingsKey[] {
    return ['requestRecipient', 'serviceGroupSetting'];
}

function serviceOrganizationSettingsReferralSmallComponentsList(): SettingsKey[] {
    return [
        'recipientIsOwnOrganization',
        'requestRecipient',
        'somnologyOrganization',
        'somnologyCanReferPatientWithoutSmartphone',
        'serviceGroupSetting',
    ];
}

function serviceOrganizationSettingsCounselingComponentsList(): SettingsKey[] {
    return ['serviceGroupSetting'];
}

export function serviceOrganizationSettingsComponentsList(serviceType: ServiceType) {
    switch (serviceType) {
        case ServiceType.examination:
            return serviceOrganizationSettingsExaminationComponentsList();
        case ServiceType.consultation:
            return serviceOrganizationSettingsConsultationComponentsList();
        case ServiceType.referral:
            return serviceOrganizationSettingsReferralComponentsList();
        case ServiceType.referralSmall:
            return serviceOrganizationSettingsReferralSmallComponentsList();
        case ServiceType.counseling:
            return serviceOrganizationSettingsCounselingComponentsList();
        default:
            return undefined;
    }
}
